import _ from 'lodash'

import ApiBrand from '@/models/api/brand'
import CouponCollection from '../models/coupon-collection'
import CouponPage from '../models/coupon-page'
import PagingSetting, { defaultPagingSetting } from '../models/paging-setting'

export default class CreateCouponPageInteractor {
  constructor(
    private setting: PagingSetting = defaultPagingSetting
  ) {}

  createBrandPage(
    brandEnglishName: string,
    pageNumber: number,
    collection: CouponCollection,
    brands: ApiBrand[]
  ): CouponPage {
    const startAt = (pageNumber - 1) * this.setting.perPage
    const limit = this.setting.perPage
    const coupons = collection.commonOrBrandCouponsWithRange(brandEnglishName, startAt, limit)

    const brand: ApiBrand | undefined = _.find(brands, (b) => {
      return b.englishNameIs(brandEnglishName)
    })
    const brandName = brand ? brand.name : ''

    return new CouponPage(
      brandEnglishName,
      brandName,
      pageNumber,
      coupons,
      limit
    )
  }
}
